import React, { memo } from 'react';
import { 
  Container, 
  Image, 
  Titulo, 
  Line1, 
  LogoContainer, 
  BannerInferior, 
  ContenidoInferior ,
  Patrocinado ,
  LogoCRSur 
} from './stylebannerbellavista'; 

import fondo from './bellavistafoto.jpg';
import logo from './BELLAVISTA.png';
import crsur from './CRSur.png';

const BannerAcademy = () => {
  return (
    <>
      {/* Banner Principal */}
      <Container>
        <Image src={fondo} alt="imagen fondo" />
        <Titulo>
          <Line1>BELLAVISTA HUELVA CLUB</Line1>
          <LogoContainer>
            <img src={logo} alt="Logo" style={{ width: '180px', height: '180px' }} />
          </LogoContainer>
        </Titulo>
      </Container>

      {/* Banner Inferior con CR SUR */}
{/* Banner Inferior con texto + CR SUR */}
<BannerInferior>
  <ContenidoInferior>
    <Patrocinado>Patrocinado por:</Patrocinado>
    <LogoCRSur src={crsur} alt="CR Sur" />
  </ContenidoInferior>
</BannerInferior>

    </>
  );
};

export default memo(BannerAcademy);
